import OnOffIcon from './OnOffIcon';

export default OnOffIcon;
